import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {},
  fields: {
    // we're controling the grid's row spacing
    // because HvGrid still doesn't support it to
    // be different from the column spacing.
    "$root &>div": {
      paddingTop: 5,
      paddingBottom: 0,
    },
  },
  input: {
    height: 86,
  },
  noEventType: {
    marginBottom: theme.hv.spacing.sm,
  },
  link: {
    cursor: "pointer",
  },
}));

export default useStyles;
